import {
  ROLE_DIGITAL_HEALTHCARE,
  ROLE_WELLNESS_STIMULATION,
  ROLE_VAPING,
  ROLE_STAFF,
  ROLE_DEMO_CUSTOMER,
  ROLE_LOGISTIC_MANGER,
  ROLE_LOGISTIC_MANGER_READ,
} from 'App/constants/Roles';
import {
  CAT_PRODUCTS,
  CAT_CUSTOMERS,
  CAT_PROJECTS,
  CAT_AGENTS,
  CAT_COURIER_DELIVERY_SERVICES,
  CAT_WEBSITE_DEALS,
  CAT_INFO_REQUESTS,
  CAT_ANALYZE_REQUESTS,
  CAT_WEBSITE_SERVICES,
  CAT_WEBSITES,
  CAT_STATUSES,
  CAT_ATTENDING_REQUESTS,
} from 'App/constants/categories';

export const SUB_PRODUCTS_VAPING_DEV = 'smoking-alternatives'; // Vaping device
export const SUB_PRODUCTS_DHW_DEV = 'digital-health-and-wellbeing-device'; // Digital Health and Wellbeing device
export const SUB_PRODUCTS_WNS_DEV = 'wellness-and-stimulation'; // Wellness and Stimulation
export const PRODUCTS_CLASSIFICATION = 'classification';
export const TEARDOWN_REPORTS = 'teardown-reports';
export const SUB_PRODUCTS_VAPING_DEV_ID = 1;
export const SUB_PRODUCTS_DHW_DEV_ID = 2;
export const SUB_PRODUCTS_WNS_DEV_ID = 3; // Wellness and Stimulation
export const SUB_PRODUCTS_TEARDOWN_REPORTS = 4;

export const SUB_PRODUCT_ORDERS = 'orders';
export const SUB_PRODUCT_ORDERS_SA = 'smoking-alternatives';
export const SUB_PRODUCT_ORDERS_WS = 'wellness-and-stimulation';
export const SUB_ORDERS_SA = 'orders-smoking-alternatives';
export const SUB_ORDERS_WS = 'orders-wellness-and-stimulation';
export const SUB_CUSTOMERS = CAT_CUSTOMERS;
export const SUB_PROJECTS = CAT_PROJECTS;
export const SUB_AGENTS = CAT_AGENTS;
export const SUB_COURIER_DELIVERY_SERVICES = CAT_COURIER_DELIVERY_SERVICES;
export const SUB_WEBSITE_DEALS = CAT_WEBSITE_DEALS;
export const SUB_WEBSITE_DEALS_DEALS = 'deals';
export const SUB_INFO_REQUESTS = CAT_INFO_REQUESTS;
export const SUB_ANALYZE_REQUESTS = CAT_ANALYZE_REQUESTS;
export const SUB_WEBSITE_SERVICES = CAT_WEBSITE_SERVICES;
export const SUB_WEBSITES = CAT_WEBSITES;
export const SUB_STATUSES = CAT_STATUSES;
export const SUB_ATTENDING_REQUESTS = CAT_ATTENDING_REQUESTS;
export const SUB_WIMS_REGISTRATIONS = 'wims_registrations';
export const SUB_CORE_ACCOUNTS = 'core_accounts';

export const PRODUCTS_SUBCATEGORIES = [
  SUB_PRODUCTS_VAPING_DEV,
  SUB_PRODUCTS_DHW_DEV,
  SUB_PRODUCTS_WNS_DEV,
  TEARDOWN_REPORTS,
];
export const ORDERS_SUBCATEGORIES = [
  SUB_ORDERS_SA,
  SUB_ORDERS_WS,
  SUB_WEBSITE_DEALS,
  SUB_INFO_REQUESTS,
  SUB_ANALYZE_REQUESTS,
];

export const SUGGESTED_FILTER_TYPE = 'suggested';
export const COMMON_FILTER_TYPE = 'common';
export const PATENT_RESEARCH_FILTER_TYPE = 'patent_research';

export const USP_TYPE_ID = 36;

export const PRODUCT_REAL_CATEGORIES = [
  {
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    role: ROLE_VAPING,
    alias: SUB_PRODUCTS_VAPING_DEV,
    title: 'Smoking Alternatives',
    color: '#EF746F',
  },
  {
    id: SUB_PRODUCTS_DHW_DEV_ID,
    role: ROLE_DIGITAL_HEALTHCARE,
    alias: SUB_PRODUCTS_DHW_DEV,
    title: 'Digital Health and Wellbeing devices',
    color: '#4ECDC4',
  },
  {
    id: SUB_PRODUCTS_WNS_DEV_ID,
    role: ROLE_WELLNESS_STIMULATION,
    alias: SUB_PRODUCTS_WNS_DEV,
    title: 'Wellness and Stimulation',
    color: '#1D98F8',
  },
];

export const PRODUCTS_SUBCATEGORIES_MAP = {
  [SUB_PRODUCTS_VAPING_DEV]: {
    title: 'Smoking Alternatives',
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    requiredRoles: [ROLE_VAPING],
    slug: SUB_PRODUCTS_VAPING_DEV,
    customIcon: true,
  },
  [TEARDOWN_REPORTS]: {
    title: 'Teardown reports',
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    parent: CAT_PRODUCTS,
    customIcon: true,
  },
  [PRODUCTS_CLASSIFICATION]: {
    title: 'Classification',
    id: SUB_PRODUCTS_VAPING_DEV_ID,
    parent: CAT_PRODUCTS,
    customIcon: true,
  },
  [SUB_PRODUCTS_DHW_DEV]: {
    hint: 'Digital Health and Wellbeing devices',
    title: 'DH&W devices',
    id: SUB_PRODUCTS_DHW_DEV_ID,
    requiredRoles: [ROLE_DIGITAL_HEALTHCARE],
    divider: true,
    slug: SUB_PRODUCTS_DHW_DEV,
    customIcon: true,
  },
  [SUB_PRODUCTS_WNS_DEV]: {
    hint: 'Wellness and Stimulation',
    title: 'W&S products',
    id: SUB_PRODUCTS_WNS_DEV_ID,
    requiredRoles: [ROLE_WELLNESS_STIMULATION],
    slug: SUB_PRODUCTS_WNS_DEV,
    customIcon: true,
  },
};

// Single source of truth for subcategory guards: the same requiredRoles that manage locks
// in the sidebar and CMS tabs. ROLE_STAFF alone doesn't grant access to a subcategory—only
// paired with a category role; otherwise, any employee would be assigned to all categories.
export function buildSubcategoryRestrictions(moduleRole = null) {
  const map = {};
  for (const [slug, { requiredRoles }] of Object.entries(PRODUCTS_SUBCATEGORIES_MAP)) {
    if (!requiredRoles) {
      continue;
    }
    map[slug] = [
      ...requiredRoles.flatMap((role) =>
        moduleRole
          ? [
              [ROLE_STAFF, role],
              [moduleRole, role],
            ]
          : [role]
      ),
      ROLE_DEMO_CUSTOMER,
    ];
  }
  return { param: 'subcategory', map };
}

const ordersRoles = (categoryRole) => [
  [ROLE_LOGISTIC_MANGER, categoryRole],
  [ROLE_LOGISTIC_MANGER_READ, categoryRole],
];

// Листинги ветки заказов: логистическая роль И категорийная.
export const CRM_ORDERS_RESTRICTIONS = {
  [SUB_ORDERS_SA]: ordersRoles(ROLE_VAPING),
  [SUB_ORDERS_WS]: ordersRoles(ROLE_WELLNESS_STIMULATION),
};

// Только категорийная часть — для форм, где право на запись уже задано meta.restriction.
export const CRM_ORDERS_CATEGORY_ROLE = {
  [SUB_ORDERS_SA]: ROLE_VAPING,
  [SUB_ORDERS_WS]: ROLE_WELLNESS_STIMULATION,
};

export const PRODUCT_SUB_CATEGORIES_FOR_TABLE = {
  [SUB_PRODUCTS_VAPING_DEV_ID]: {
    abbr: 'SA',
    tooltip: 'Smoking Alternatives',
  },
  [SUB_PRODUCTS_DHW_DEV_ID]: {
    abbr: 'DH&W',
    tooltip: 'Digital Health And Wellbeing Device',
  },
  [SUB_PRODUCTS_WNS_DEV_ID]: {
    abbr: 'W&S',
    tooltip: 'Wellness And Stimulation',
  },
};
